import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import logo from "../../../assets/landingFeatures/explorer.png";
import { Button} from "antd";

import "./jobListingSearchResults.scss";
import JobListingSearchResults from "../jobListingSearchResults";
import FooterNuJobs from "../../footerNuJobs";
import JobListingsPageHeader from "../jobListingPageHeader";

export default function JobListingSearchResultsPage(props) {

  const navigate = useNavigate();
  const handleSignin = () => {
    navigate("/nujobsotpprocess", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    }); 
  };

  const handlePostJobs = () => {
    navigate("/otpprocess/nujobs", {
      state: {
        reason: "start",
        trigger: "signin",
      },
    });    
  };

  return (
    <div className="jobListingSearchResultsPage-wrapper">
       <JobListingsPageHeader/>

       <JobListingSearchResults resultHandler= {null} loggedIn= {false}/>

       <div className="landing-footer">
          <FooterNuJobs/>
       </div>         
    </div>
  );
}
